/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import axios from 'axios'
import env from '../common/env';
import { ACTION_TYPES } from './ActionTypes';
import asyncCallHandler from '../common/utils/AsyncCallHandler';
import {getItem, setItem,deleteItem} from '../common/utils/StorageManager';
const CryptoJS = require("crypto-js");

export const getUsers = () => {
    //sample api call
    return (dispatch) => {
        axios.get('https://jsonplaceholder.typicode.com/users').then(res => {
            dispatch({ type: ACTION_TYPES.FETCH_USER_DATA, payload: res.data })
        }).catch(err => {
            dispatch({ type: ACTION_TYPES.FETCH_USER_DATA, payload: err })
        });
    }

}

export const dispatchIesInfo = (info) => {
    return (dispatch) => {
            dispatch({ type: ACTION_TYPES.FETCH_USER_DATA, payload: info })
    }
}

export const getFusionKey = () => {
    let token = getItem('accessToken')
    let userData = getItem('userData');
    let schoolId = userData ? userData.schoolId : '';
    const url =
        'fusionChartData?schoolId=' + schoolId

    return (dispatch) => {
    asyncCallHandler(env.COMMON_END_POINT, url, token)
        .then((response) => {            
            const val = decryptMethod(response.data.data, 'SW5zaWdodHMkQXBwI0FIQg==')
            setItem('FusionKey', val)
            dispatch({ type: ACTION_TYPES.FETCH_FUSION_DATA, payload: val })           
        })
        .catch((error) => {
            dispatch({ type: ACTION_TYPES.FETCH_FUSION_DATA, payload: error })
          
        })
    }

}


export const getIesUserInfo = () => {
    let token = getItem('accessToken')
    let edwData ={};
     return (dispatch) => {
        asyncCallHandler(env.COMMON_END_POINT  , env.USER_END_POINT, token).then(res => {
            setItem('userData', res.data)
            if (res.data && res.data.impersonateOrgId && res.data.impersonateUserId) {
                edwData = { 'edwSId': res.data.impersonateOrgId, 'edwUId': res.data.impersonateUserId }
                localStorage.setItem('edwData', JSON.stringify(edwData));
                setItem('edwData', edwData)
            } else {
                localStorage.removeItem('edwData');
                deleteItem('edwData')
            }          
            dispatch({ type: ACTION_TYPES.FETCH_USER_DATA, payload: res.data })
        }).catch((err,data) => {
            let payload = {"error": true, "message": err.message};
            setItem('userData', payload)
            console.log('Error', err.message);
            dispatch({ type: ACTION_TYPES.FETCH_USER_DATA, "payload": payload })
        });
    }

}


const decryptMethod = (strToDecrypt, secretKey) => {
   var parsedBase64Key = CryptoJS.enc.Base64.parse(secretKey);
    const decryptedData = CryptoJS.AES.decrypt(strToDecrypt, parsedBase64Key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    // this is the decrypted data as a string
    const decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
    return decryptedText;
}